<ngx-qrcode class="qr" *ngIf="qr" [qrc-value]="qr"></ngx-qrcode>